const map = {
	"./authors.js": 97676,
	"./automatedTags.js": 47207,
	"./breakdowns.js": 87230,
	"./categories.js": 63606,
	"./countries.js": 2782,
	"./index.js": 3936,
	"./outlets.js": 26874
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38868;